var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget widget-table-one"},[_vm._m(0),_c('div',{staticClass:"widget-content"},_vm._l((_vm.topSellingProducts),function(p){return _c('TopProduct',{key:p.product,attrs:{"productItem":p}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-heading"},[_c('h5',{},[_vm._v("Top 5 produits les plus vendus")])])
}]

export { render, staticRenderFns }